import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { ITagEntity } from '../interfaces/tag-entity';
import { BaseDataService } from './base.data.service';

@Injectable({ providedIn: 'root' })
export class TaggingService extends BaseDataService {
  private url = '/api/tagging';
  private entityTitle = 'Tag';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAllTags(): Observable<ITagEntity[]> {
    return this.http.get<ITagEntity[]>(`${this.url}/getAll`);
  }

  public createTag(newTag): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}/create`, newTag),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  public editTag(tag): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}/edit`, tag),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  public deleteTag(id: number): Promise<any> {
    return this.handleRequest(
      this.http.delete(`${this.url}/delete/${id}`),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }

  public activateTag(id: number): Promise<any> {
    // not using the handleRequest object here to prevent message in ui
    return this.http.post(`${this.url}/activate/${id}`, null).toPromise();
  }

  public deactivateTag(id: number): Promise<any> {
    return this.http.post(`${this.url}/deactivate/${id}`, null).toPromise();
  }
}
